import axios, { type AxiosInstance } from "axios";
// import ADLToken from '../../../Server/ADL-Token'

export default async function makeApi(): Promise<AxiosInstance> {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL ?? "",
  });

  api.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem("authToken") || "";
      try {
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
          if (config.method === "patch" && config.data) {
            config.headers["Content-Type"] = "application/json-patch+json";
          } else if (
            config.method === "put" &&
            config.data.notificationSentToId
          ) {
            config.headers["Content-Type"] = "application/json";
          } else if (config.method === "put") {
            config.headers["Content-Type"] = "multipart/form-data";
          } else if (config.method === "post" && config.data.base64Image) {
            config.headers["Content-Type"] = "multipart/form-data";
          }
        } else {
          delete config.headers.Authorization;
        }
      } catch (error) {
        console.error("Error fetching Auth0 token:", error);
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response.data, // return data object
    async (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("customerInfo");
        const redirectUrl =
          `${process.env.REACT_APP_LKQPORTAL_URL}logout` || "/";
        window.location.replace(redirectUrl);
      }
      return Promise.reject(error);
    }
  );

  return api;
}
